<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    methods: {}
  }
</script>

<style>
  /* 引导框样式 */
  .introjs-skipbutton {
    /* 基础样式 */
    color: black !important;
    font-size: 16px !important;
  }

  .introjs-skipbutton:hover {
    border: 1px solid black !important;
    border-radius: 5px !important;
    transform: translateY(-1px) !important;
  }

  .introjs-tooltip {
    background-color: white !important;
    color: black !important;
  }

  .introjs-button {
    color: black !important;
  }

  .introjs-button:hover {
    border: 1px solid black !important;
    color: black !important;
  }

  .introjs-nextbutton,
  .introjs-donebutton {
    color: #000000 !important;
    border: 1px solid black !important;
  }

  .introjs-arrow {
    border-bottom-color: white !important;
  }

  input[aria-hidden="true"] {
    display: none !important;
  }

  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue